<template>
    <q-modal v-model="showLogin">
        <div class="layout-padding">

            <div class="modal-close">
                <q-btn color="primary" round dense icon="close" @click="showLogin = false;$router.push('/')"></q-btn>
            </div>

            <div class="q-py-lg">

                <template v-if="!user">
                    <!-- <form @submit.prevent="login(slug)"
                          class="gutter-xs q-pa-xs"
                          @keydown="form.onKeydown($event)">

                        <div class="text-center"><img :src="logo" width="200px"/></div>

                        <v-input path="msisdn"
                                 v-model="form.msisdn"
                                 :label="$t('Number')"
                                 type="text"
                                 color="highlight"
                                 :form="form">
                        </v-input>

                        <div class="row justify-center">
                            <v-submit :label="$t('log in')"
                                      :loadingLabel="$t('validating...')"
                                      color="primary"
                                      :form="form">
                            </v-submit>
                        </div>

                    </form>

                    <template slot="actions">
                        <q-btn flat color="highlight" @click="$router.push({ name: 'password.request' })"
                               :label="$T('forgot your password?')"></q-btn> 
                    </template>-->
                </template>

                <div v-else class="q-pa-xl text-center">
                    {{ $T('you are logged in!') }}
                </div>

            </div>
        </div>
    </q-modal>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {QModal, QSpinnerPuff, QBtn, QCheckbox, QInput} from 'quasar-framework'

    export default {
        name: 'VLogin',
        components: {
            QModal,
            QBtn,
            QSpinnerPuff,
            QCheckbox,
            QInput
        },

        data: () => ({
            logo: `${config.appUrl}${config.devAssetsFolder}/img/p4f.svg`
        }),

        computed: {
            ...mapGetters({
                user: 'auth/user',
                settings: 'local/settings'
            }),
            showLogin: {
                get() {
                    return this.settings('login')
                },
                set(value) {
                    this.$store.dispatch('local/set', {key: 'login', value})
                }
            },
            slug: {
                get() {
                    return this.settings('redirect-route')
                },
                set(value) {
                    this.$store.dispatch('local/set', {key: 'redirect-route', value})
                }
            },
        },

        methods: {
            redirectToWapBilling() {
                axios.get(`${config.appUrl}/api/service-url`)
                    .then(({data}) => {
                        window.location.href = data;
                    })
            },
            async login(slug) {
                this.form.redirectTo = (slug != undefined) ? slug : "/";

                // Submit the form.
                if(!this.$route.query.hasOwnProperty('error_n'))
                {
                    slug = config.appUrlPortal.replace("/", "*").replace("/", "*")+'*'+slug.replace("/", "")
                    axios.post(`${config.SkySMSUrl}/login`,{redirectTo: slug, portal: portal}).then(function(response){
                        window.location.href = response.data;
                    })
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/auth/login.vue